/**
 * @copyright (C) 2025, rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 *
 * @author
 * Heeseok Shin (hsshin@rsupport.com)
 *
 * @description
 *
 * @created at Mon Jun 30 2025
 **/

import NoticeService from "./NoticeService";

export default class NoticeServiceAPI {
	private static instance: NoticeService;

	private constructor(events: API.Events) {
		NoticeServiceAPI.instance = new NoticeService(events);
	}

	public static getInstance(events: API.Events = {}) {
		if (!this.instance) {
			this.instance = new NoticeService(events);
		}
		return this.instance;
	}
}
